var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row donors-list"},[_c('div',{staticClass:"col-12"},[(!_vm.output)?_c('p',[_vm._v("Loading")]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.output)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }